export var SchemaRegistryAuthType;
(function (SchemaRegistryAuthType) {
    SchemaRegistryAuthType["SCHEMA_REGISTRY_AUTH_TYPE_NONE"] = "none";
    SchemaRegistryAuthType["SCHEMA_REGISTRY_AUTH_TYPE_BASIC"] = "basic";
    SchemaRegistryAuthType["SCHEMA_REGISTRY_AUTH_TYPE_BEARER"] = "bearer";
    SchemaRegistryAuthType["SCHEMA_REGISTRY_AUTH_TYPE_MTLS"] = "mtls";
})(SchemaRegistryAuthType || (SchemaRegistryAuthType = {}));
